<ng-container *ngIf="comments$ | async as comments">
    <div class="form-container" *ngIf="!lastYear">
        <form [formGroup]="commentForm" (ngSubmit)="addComment()">
            <div class="form-controls">
                <div>
                    <textarea
                        hamInput
                        formControlName="text"
                        placeholder="{{ 'aumico_reports_add_a_new_comment_placeholder' | i18next }}"
                        [ngClass]="{ expanded: isTextareaFocused, collapsed: !isTextareaFocused }"
                        (focus)="onTextareaFocus()"
                        (blur)="onTextareaBlur()"
                        (cancel)="cancel()"
                    ></textarea>
                </div>
                <div class="form-badges" *ngIf="commentForm.get('text')?.value?.trim() !== ''">
                    <span>{{ 'aumico_reports_mark_comment_as' | i18next }}</span>
                    <ham-badge-toggle
                        formControlName="isInternal"
                        color="primary"
                        icon="assets/hamIcons/message-caption-outline.svg"
                        >{{ 'aumico_reports_is_internal_comment' | i18next }}</ham-badge-toggle
                    >
                    <ham-badge-toggle
                        formControlName="isExternal"
                        color="purple"
                        icon="assets/hamIcons/messages-outline.svg"
                        >{{ 'aumico_reports_is_external_comment' | i18next }}</ham-badge-toggle
                    >
                    <ham-badge-toggle
                        formControlName="isPendency"
                        color="yellow"
                        icon="assets/hamIcons/clock-outline.svg"
                        >{{ 'aumico_reports_is_pendancy_comment' | i18next }}</ham-badge-toggle
                    >
                    <ham-badge-toggle
                        formControlName="needsReview"
                        color="red"
                        icon="assets/hamIcons/eye-outline.svg"
                        >{{ 'aumico_reports_is_review_comment' | i18next }}</ham-badge-toggle
                    >
                </div>
            </div>
            <div class="action-buttons">
                <ham-button
                    type="submit"
                    size="sm"
                    [disabled]="commentForm.invalid || !commentForm.get('text')?.value?.trim()"
                    (click)="addComment()"
                >
                    {{
                        editingCommentId
                            ? ('aumico_reports_add_edit_comments_button' | i18next)
                            : ('aumico_reports_add_new_comments_button' | i18next)
                    }}
                </ham-button>
            </div>
        </form>
    </div>

    <div class="comments-wrapper">
        <div *ngFor="let comment of comments; let i = index" class="comment-container">
            <div class="comment-head">
                <app-editor-meta-info [meta]="{ createdByName: comment.createdByName, createdAt: comment.createdAt }">
                </app-editor-meta-info>

                <div class="comment-menu" *ngIf="!lastYear">
                    <span
                        hamIconShapes
                        icon="assets/hamIcons/dots-vertical.svg"
                        [variant]="'white'"
                        [size]="'regular'"
                        [type]="'circle'"
                        (click)="toggleCommentMenu($event, i)"
                    ></span>
                    <div
                        class="menu-flyout"
                        hamFlyout
                        *ngIf="isMenuOpenIndex === i"
                        (closeFlyout)="closeCommentMenu()"
                        [position]="menuPosition"
                    >
                        <ul>
                            <li (click)="editComment(comment)">
                                <span class="ham-icon"> <i class="edit-icon"></i> </span
                                ><span class="menu-item-text">Edit</span>
                            </li>
                            <li (click)="markAsInternal(!comment.isInternal, comment)">
                                <span class="ham-icon"> <i class="message-caption-icon"></i> </span>
                                <span class="menu-item-text">
                                    {{ 'aumico_reports_mark_as_internal_comment' | i18next }}
                                </span>
                                <span
                                    hamCheckbox
                                    [checked]="comment.isInternal"
                                    (change)="markAsInternal($event.checked, comment)"
                                ></span>
                            </li>
                            <li (click)="markAsExternal(!comment.isExternal, comment)">
                                <span class="ham-icon"> <i class="messages-icon"></i> </span
                                ><span class="menu-item-text">{{
                                    'aumico_reports_mark_as_external_comment' | i18next
                                }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="comment.isExternal"
                                    (change)="markAsExternal($event.checked, comment)"
                                ></span>
                            </li>
                            <li (click)="markAsPending(!comment.isPendency, comment)">
                                <span class="ham-icon"> <i class="clock-icon"></i> </span
                                ><span class="menu-item-text">{{
                                    'aumico_reports_mark_comment_as_pendency' | i18next
                                }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="comment.isPendency"
                                    (change)="markAsPending($event.checked, comment)"
                                ></span>
                            </li>
                            <li (click)="markAsNeedsReview(!comment.needsReview, comment)">
                                <span class="ham-icon"> <i class="eye-icon"></i> </span
                                ><span class="menu-item-text">{{
                                    'aumico_reports_mark_as_review_comment' | i18next
                                }}</span>
                                <span
                                    hamCheckbox
                                    [checked]="comment.needsReview"
                                    (change)="markAsNeedsReview($event.checked, comment)"
                                ></span>
                            </li>
                            <li *ngIf="lastYear" (click)="copyToClipboard(comment.text)">
                                <span class="ham-icon"> <i class="copy-icon"></i> </span
                                ><span class="menu-item-text">{{ 'aumico_reports_copy_comment' | i18next }}</span>
                            </li>
                            <li *ngIf="!lastYear" class="spacer"></li>
                            <li
                                *ngIf="!lastYear"
                                (click)="deleteComment(comment)"
                                style="color: var(--red-600, #e02424)"
                            >
                                <span class="ham-icon"> <i class="x-icon"></i> </span
                                ><span class="menu-item-text">{{ 'aumico_reports_delete_comment' | i18next }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div
                class="comment-badges"
                *ngIf="comment.isPendency || comment.isInternal || comment.isExternal || comment.needsReview"
            >
                <span
                    *ngIf="comment.isInternal"
                    hamBadge
                    color="primary"
                    icon="assets/hamIcons/message-caption-outline.svg"
                    >{{ 'aumico_reports_is_internal_comment' | i18next }}</span
                >
                <span *ngIf="comment.isExternal" hamBadge color="purple" icon="assets/hamIcons/messages-outline.svg">{{
                    'aumico_reports_is_external_comment' | i18next
                }}</span>
                <span *ngIf="comment.isPendency" hamBadge color="yellow" icon="assets/hamIcons/clock-outline.svg">{{
                    'aumico_reports_is_pendancy_comment' | i18next
                }}</span>
                <span *ngIf="comment.needsReview" hamBadge color="red" icon="assets/hamIcons/eye-outline.svg">{{
                    'aumico_reports_is_review_comment' | i18next
                }}</span>
            </div>
            <div class="comment-body">
                <div class="comment-text" [ngClass]="{ 'last-year': lastYear }">
                    {{ comment.text }}
                </div>
            </div>
            <div class="to-delete">
                <span *ngIf="lastYear" class="copy-button" (click)="copyToClipboard(comment.text)"><i></i></span>
            </div>
            <!-- Spacer element added conditionally -->
            <div *ngIf="i < comments.length - 1" class="spacer"></div>
        </div>
    </div>
</ng-container>
